import { render } from "./hr-loader-block.vue?vue&type=template&id=a48cff8c&scoped=true"
import script from "./hr-loader-block.vue?vue&type=script&lang=js"
export * from "./hr-loader-block.vue?vue&type=script&lang=js"

import "./hr-loader-block.vue?vue&type=style&index=0&id=a48cff8c&scoped=true&lang=css"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604021339/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a48cff8c"]])

export default __exports__